import { SHOW_NOTIFICATION, HIDE_NOTIFICATION, CLEAR_ALL } from '../constants';

interface NotificationState {
  visible: boolean;
  type: 'success' | 'error' | 'warning' | 'info' | '';
  title: string;
  message: string;
}

const initialState: NotificationState = {
  visible: false,
  type: '',
  title: '',
  message: '',
};

const notificationReducer = (state = initialState, { type, payload }: { type: string; payload?: any }): NotificationState => {
  switch (type) {
    case SHOW_NOTIFICATION:
      return {
        visible: true,
        type: payload.type || 'info',
        title: payload.title || '',
        message: payload.message || '',
      };
    case HIDE_NOTIFICATION:
      return { ...initialState };
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default notificationReducer;
